import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { IdLoginComponent } from './pages/id-login/id-login.component';
import { LoginRegisterComponent } from './pages/login-register/login-register.component';
import { RegisterVerifyContactComponent } from './pages/register-verify-contact/register-verify-contact.component';
import { SetPasswordComponent } from './pages/set-password/set-password.component';
import { ReserveLocationComponent } from './pages/reserve-location/reserve-location.component';
import { ReserveComponent } from './pages/reserve/reserve.component';
import { ReserveInfoComponent } from './pages/reserve-info/reserve-info.component';
import { ReserveHealthComponent } from './pages/reserve-health/reserve-health.component';
import { ReserveLoadingComponent } from './pages/reserve-loading/reserve-loading.component';
import { ReserveResultComponent } from './pages/reserve-result/reserve-result.component';
import { ReserveConfirmSurveyComponent } from './pages/reserve-confirm-survey/reserve-confirm-survey.component';
import { ReserveAddComponent } from './pages/reserve-add/reserve-add.component';
import { ReserveConfirmComponent } from './pages/reserve-confirm/reserve-confirm.component';
import { ReserveConfirmReminderComponent } from './pages/reserve-confirm-reminder/reserve-confirm-reminder.component';
import { AppointmentInfoComponent } from './pages/appointment-info/appointment-info.component';
import { AppointmentTimeComponent } from './pages/appointment-time/appointment-time.component';
import { AppointmentConfirmComponent } from './pages/appointment-confirm/appointment-confirm.component';
import { AppointmentCompleteComponent } from './pages/appointment-complete/appointment-complete.component';
import { BusinessReserveResultComponent } from './pages/business-reserve-result/business-reserve-result.component';
import { BusinessReserveCompareComponent } from './pages/business-reserve-compare/business-reserve-compare.component';
import { BusinessLoginComponent } from './pages/business-login/business-login.component';
import { MemberComponent } from './pages/member/member.component';
import { HealthQuestionnaireComponent } from './pages/health-questionnaire/health-questionnaire.component';
import { ReportQueryComponent } from './pages/report-query/report-query.component';
import { ModifyInfoComponent } from './pages/modify-info/modify-info.component';
import { MyReservationComponent } from './pages/my-reservation/my-reservation.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { authguardGuard } from './authguard.guard';
import { ConsentFormComponent } from './pages/consent-form/consent-form.component';
import { CanDeactivateGuard } from './shared/guards/can-deactivate.guard';
import { NotAvailableComponent } from './pages/not-available/not-available.component';
import { NewHomePageComponent } from './pages/new-homePage/new-homePage.component';
import { HealthPlanComponent } from './pages/health-plan/health-plan.component';

export const routes: Routes = [
  { path: '', redirectTo: '/healthcheck', pathMatch: 'full' },
  { path: 'healthcheck', component: NewHomePageComponent },
  { path: 'healthcheck/healthplan', component: HealthPlanComponent },
  { path: 'healthcheck/idlogin', component: IdLoginComponent },
  { path: 'healthcheck/login', component: LoginRegisterComponent },
  { path: 'healthcheck/passwordset', component: SetPasswordComponent },
  { path: 'healthcheck/consentform', component: ConsentFormComponent },
  {
    path: 'healthcheck/contactinfo',
    component: RegisterVerifyContactComponent,
  },
  { path: 'healthcheck/companylogin', component: BusinessLoginComponent },
  
  // 特殊活動頁面的預約流程 - 使用 /reserve 子路徑
  {
    path: 'healthcheck/healthplan/reserve',
    component: ReserveComponent,
    canActivate: [authguardGuard], 
    children: [
      { path: 'personalhistory', component: ReserveHealthComponent },
      { path: 'familyhistory', component: ReserveHealthComponent },
      { path: 'symptoms', component: ReserveHealthComponent },
      { path: 'loading', component: ReserveLoadingComponent },
      { path: 'personalplan', component: ReserveResultComponent },
    ],
  },

  // 一般預約流程
  {
    path: 'healthcheck/reserve',
    component: ReserveComponent,
    canActivate: [authguardGuard],
    children: [
      { path: 'location', component: ReserveLocationComponent },
      { path: 'personalinfo', component: ReserveInfoComponent },
      { path: 'personalhistory', component: ReserveHealthComponent },
      { path: 'familyhistory', component: ReserveHealthComponent },
      { path: 'symptoms', component: ReserveHealthComponent },
      { path: 'loading', component: ReserveLoadingComponent },
      { path: 'personalplan', component: ReserveResultComponent },
      { path: 'additem', component: ReserveAddComponent },
      { path: 'overview', component: ReserveConfirmComponent },
      { path: 'evaluation', component: ReserveConfirmSurveyComponent },
      { path: 'reminder', component: ReserveConfirmReminderComponent },
      { path: 'bookinfo', component: AppointmentInfoComponent },
      { path: 'timeselect', component: AppointmentTimeComponent },
      { path: 'review', component: AppointmentConfirmComponent },
      { path: 'complete', component: AppointmentCompleteComponent },
      { path: 'companyplan', component: BusinessReserveResultComponent },
      { path: 'plancompare', component: BusinessReserveCompareComponent },
    ],
  },
  {
    path: 'healthcheck/member',
    component: MemberComponent,
    canActivate: [authguardGuard],
    children: [
      { path: 'healthcheck/member', redirectTo: 'mybooking', pathMatch: 'full' },
      { path: 'mybooking', component: MyReservationComponent },
      { path: 'form', component: HealthQuestionnaireComponent, canDeactivate: [CanDeactivateGuard] },
      { path: 'report', component: ReportQueryComponent },
      { path: 'editprofile', component: ModifyInfoComponent },
    ],
  },
  {
    path: 'not-found',
    component: NotFoundComponent,
    data: { hideHeader: true },
  },
  {
    path: 'not-available',
    component: NotAvailableComponent,
  },
  { path: '**', redirectTo: '/not-found' },
];
